import React from "react";

function AdminFooter() {
  return (
    <div className="nk-footer">
      <div className="container-fluid">
        <div className="nk-footer-wrap">
          <div className="nk-footer-copyright">
            &copy; 2024 Admin. All Rights Reserved.
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminFooter;
